export const isIOS = () => {
  return /ipad|iphone|ipod/i.test(navigator.userAgent)
}
export const isAndroid = () => {
  return /android/i.test(navigator.userAgent)
}
